<template>
  <div class="btn-gray">
    <router-link to="/resolucoes">
      <mdicon name="FileDocumentMultipleOutline" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-xl text-center font-semibold">{{ title }}</h2>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
}
</script>
